require('./bootstrap.js');

require('../modernizr-webp.js');
// require('../jasny/jasny-bootstrap.js');
require('remodal');
require('../modules/remodal/mobile-fix');
require('../assign-general-functions-to-window.js');
import supportedBrowserNotification from '../core/supported-browser-notification';
const validBrowser = supportedBrowserNotification();

import ContactFormValidator from '../validation/ContactFormValidator';
import CustomerLocationHandler from '../modules/CustomerLocationHandler';
import GoogleMapsLoaderClass from '../modules/GoogleMapsLoader';
import LocationDataLoader from '../modules/LocationDataLoader';

import getMapIcon from '../modules/mapIcon';



import CustomerLocation from '../core/components/Forms/CustomerLocation.vue';
import CareersResultsPage from "./components/CareersResultsPage.vue";

if (validBrowser) {
    window.LocationDataLoader = new LocationDataLoader;
    window.ContactFormValidator = ContactFormValidator;
    window.CustomerLocationHandler = CustomerLocationHandler;
    window.customerLat = getCookieValue('lat');
    window.customerLng = getCookieValue('lng');
    window.customerPostcode = getCookieValue('postcode');
    window.customerGeolocation = getCookieValue('geolocation');
    // Create a global object for getting a new Google Maps instance
    window.GoogleMapsLoader = new GoogleMapsLoaderClass;
    // Handle detecting when Google Maps has finished loading
    window.googleMapsLoaded = () => {
        GoogleMapsLoader.mapLoaded();
    };
    // require('../live-chat/live-chat');
    require('../cookie-warning.js');
    require('../modules/polyfills/string-padStart');

    Vue.mixin({
        methods: {
            gaTag(eventCategory = '', eventAction = '', eventLabel = '') {
                customEvent(eventCategory, eventAction, eventLabel, 0);
            },
            generateLeadEvent(name = 'Misc Event', value = 0, currency = 'GBP') {
                generateLeadEvent(name, currency, value);
            },
            trackPageView() {
                trackPageView();
            }
        }
    });

    Vue.component('customer-location', CustomerLocation);
    Vue.component('careers-results-page', CareersResultsPage);

    const app = new Vue({
        el: '#careers-app'
    });

    window.getMapIcon = getMapIcon;
}


// WEBPACK FOOTER //
// ./resources/assets/js/careers/app.js